import { IconChartBar } from "@tabler/icons-react";
import { Trans } from "@lingui/macro";

import { scoredGradeMultipliers } from "../../engine/scoring";
import styles from "./RewardGradeHint.module.css";

/**
 * Compact hint that rewards scale by grade: S is the best multiplier, C the
 * lowest passing one. Same for every contract (global grade band), so it reads
 * as "how rewards work" rather than per-contract data.
 */
export function RewardGradeHint(): JSX.Element {
  const grades = scoredGradeMultipliers();
  const sMult = grades[0]?.multiplier ?? 1.2;
  const cMult = grades[grades.length - 1]?.multiplier ?? 0.55;
  return (
    <span className={styles.hint}>
      <IconChartBar size={12} aria-hidden="true" />{" "}
      <Trans>
        по грейду: S ×{sMult} … C ×{cMult}
      </Trans>
    </span>
  );
}
